import I18n from 'I18n';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { jsx as _jsx } from "react/jsx-runtime";
const NoResultsIllustration = () => /*#__PURE__*/_jsx(Illustration, {
  name: "empty-state-charts",
  alt: I18n.text('dashboard.state.noBusinessUnits.noFormsCouldBeFound'),
  marginBlockEnd: "200"
});
const NoBusinessUnits = () => /*#__PURE__*/_jsx(NavMarker, {
  name: "FORMS_DASHBOARD_NO_BUSINESS_UNITS",
  children: /*#__PURE__*/_jsx(EmptyState, {
    id: "forms-dashboard-no-results",
    "data-test-id": "forms-dashboard-no-results",
    titleText: I18n.text('dashboard.state.noBusinessUnits.noFormsCouldBeFound'),
    primaryContent: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.state.noBusinessUnits.noFormsCouldBeFoundExplanation"
    }),
    secondaryContent: /*#__PURE__*/_jsx(NoResultsIllustration, {}),
    secondaryContentWidth: 200
  })
});
export default NoBusinessUnits;